class TabsWithSliders {
  constructor(container) {
    this.container = container;
    this.tabs = container.querySelectorAll('.tabs-with-sliders__tab');
    this.panels = container.querySelectorAll('.tabs-with-sliders__slider-hld');
    this.swipers = [];
    
    this.init();
  }
  
  init() {
    // Add click event listeners to tabs
    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', (e) => this.handleTabClick(e, index));
    });
    
    // Initialize Swiper for each slider
    this.initSwipers();
  }
  
  initSwipers() {
    const sliders = this.container.querySelectorAll('.tabs-with-sliders__slider');
    
    sliders.forEach((slider, index) => {
      const swiper = new Swiper(slider, {
        slidesPerView: 1.5,
        spaceBetween: 16,
        grabCursor: true,
        freeMode: {
          enabled: true,
          sticky: false,
          momentum: true
        },
        navigation: {
          nextEl: slider.querySelector('.tabs-with-sliders__slider-nav .swiper-button-next'),
          prevEl: slider.querySelector('.tabs-with-sliders__slider-nav .swiper-button-prev'),
        },
        pagination: {
          el: slider.querySelector('.tabs-with-sliders__pagination'),
          clickable: true,
        },
        breakpoints: {
          576: {
            slidesPerView: 1.8,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 20,
            freeMode: {
              enabled: false
            },
          },
          1280: {
            slidesPerView: 4,
            spaceBetween: 20,
            freeMode: {
              enabled: false
            }
          },
          1440: {
            slidesPerView: 5,
            spaceBetween: 20,
            freeMode: {
              enabled: false
            }
          }
        }
      });
      
      this.swipers.push(swiper);
    });
  }
  
  handleTabClick(event, index) {
    event.preventDefault();
    this.switchToTab(index);
  }
  
  switchToTab(index) {
    // Remove active state from all tabs and panels
    this.tabs.forEach((tab, i) => {
      tab.classList.toggle('is-active', i === index);
      tab.setAttribute('aria-selected', i === index);
      tab.setAttribute('tabindex', i === index ? '0' : '-1');
    });
    
    this.panels.forEach((panel, i) => {
      panel.classList.toggle('is-active', i === index);
      panel.setAttribute('aria-hidden', i !== index);
    });
  }
}

// Initialize tabs when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  const tabContainers = document.querySelectorAll('.tabs-with-sliders');
  tabContainers.forEach(container => {
    new TabsWithSliders(container);
  });
});
